export const feedDATA = {
	msg: '成功',
	extend: {
		pageType: 3668,
		pageId: 4274,
		ctp: 3668,
	},
	code: '000',
	success: true,
	failure: false,
	lastId: '1.679057582523E12',
	pageSize: 20,
	resultList: [
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697682339\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '面对国际金价的持续上涨，上金所20日发布通知',
					},
					contentId: '697682339',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '黄金',
							categoryLevel: '2',
						},
						categoryName: '黄金',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '上金所紧急预警！黄金到底怎么了？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/121688/14/31300/223267/64193c04F02244421/1304e3607eb35d2f.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '43分钟前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697682339',
						templateId: 588,
						skuType: 11,
						contentType: 1,
						skuId: '21001001000001',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697682339',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697682339',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697682339',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697682339',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697682339',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#F75C38',
					forward: {
						jumpType: '7',
						productId: '21001001000001',
						jumpUrl:
							'https://m.jdjygold.com/finance-gold/newgold/index/?orderSource=1002_71_697682339',
					},
					numContent: '443.08元/克',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/138898/10/15932/1435/5fbfbbcdE6e757f46/7cfbbeee20d87c3a.png',
					skuType: 3,
					trackData: {},
					content: '民生积存金',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697665602\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '3月21日，又一批进口版号于昨晚公布，游戏ETF(159869)开盘即走高',
					},
					contentId: '697665602',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '基金',
							categoryLevel: '2',
						},
						categoryName: '股票型',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '重磅利好解读！“AI+”时代来临！',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/218566/6/24889/223310/64192806Fdfb9c029/6395434639d9bf1f.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '1小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697665602',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc114222',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697665602',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697665602',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697665602',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697665602',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697665602',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						jumpType: '7',
						productId: 'fc114222',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=012769&fundUtmSource=856&fundUtmParam=1002_71_697665602',
					},
					numContent: '+17.04%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '华夏中证动漫游戏ETF发起式联接C',
					optionalData: {
						inputData: {
							fundId: '114222',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697665602","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc114222"}',
							},
						},
						productId: '114222',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697665602","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc114222"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697660658\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '有机构认为，从国资委的表态来看，对军工央企或存在后续支持政策，包括资产重组、股权激励、集团整合、转型考核机制等。',
					},
					contentId: '697660658',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '中特估新支线！军工领衔主演，国资委发声支持，机构看好这些方向',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/64459/35/23204/9558/641921d0Fbc7b0a25/aea2017720e279ad.png?width=413&height=311',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/164322/7/36318/100635/641921d0F4362b286/fbe70fac9e7d12ec.png?width=934&height=531',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/212603/18/26886/55131/641921d0F00440802/e55603b3bc498076.png?width=911&height=372',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '2小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 3,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697660658',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc108483',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697660658',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697660658',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697660658',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697660658',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697660658',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc108483',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=005609&fundUtmSource=856&fundUtmParam=1002_71_697660658',
					},
					numContent: '-15.85%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '富国军工主题混合A',
					optionalData: {
						inputData: {
							fundId: '108483',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697660658","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc108483"}',
							},
						},
						productId: '108483',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697660658","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc108483"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697658434\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '相关事件国资委：以更大力度鼓励支持中央军工企业做强做优做大20日，国资委党委召开扩大会议，围绕政府工作报告部署要求，研究国资央企贯彻落实措施。会议指出，要以更大力度鼓励支持中央军工企业做强做优做大，指导中央企业立足自身所能积极支持国防军队建设，助力实现国家战略能力最大化。事件点评国防与安全将是2023年全球共同面对的话题。目前，全球局势存在不确定性，地缘局势动荡或将持续，全球各大国均加大军费投入。',
					},
					contentId: '697658434',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '【热点挖掘】行业大发展时期到来，军工板块大涨！',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/182599/37/33878/48110/64191ba5F4023a5cb/0069679fd199ee5c.jpg?width=520&height=312',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '中国银河证券',
					},
					title2: {
						text: '3小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697658434',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SZ-300059',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/jdminiprogram/open?jrlogin=true&jrcontainer=native&jrparam=%7B%22type%22%3A%22%7B%5C%22des%5C%22%3A%5C%22vapp%5C%22%2C%5C%22vapptype%5C%22%3A%5C%221%5C%22%2C%5C%22appId%5C%22%3A%5C%22DFEFCE0E722CAA7DA5E8A443C7689457%5C%22%2C%5C%22category%5C%22%3A%5C%22jump%5C%22%7D%22%7D',
						param: {
							type: '{"des":"vapp","vapptype":"1","appId":"DFEFCE0E722CAA7DA5E8A443C7689457","category":"jump"}',
						},
						jumpUrl: '2024',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg11.360buyimg.com/jrpmobile/jfs/t1/159881/40/23012/17649/6396e0c5Eeaf698db/c06c852a5c62094b.jpg!cc_50x50',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697658434',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697658434',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-7293',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697658434',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697658434',
							contentType: '1',
							createdPin: 'jimu_user_info-7293',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-7293',
							typeId: '4',
							pageId: '697658434',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SZ-300059%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697658434%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+0.75%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '东方财富',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697657892\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					linksArray: [
						{
							contentId: '2701134',
							jumpData: {
								jumpType: '7',
								productId: ' 央行宣布降准，本周A股能否强势反弹？',
								jumpUrl: 'https://content.jr.jd.com/jrq/#/topic?id=2701134',
							},
							text: '# 央行宣布降准，本周A股能否强势反弹？#',
							type: 1,
						},
					],
					contentTitle2: {
						text: '上周五应央行超预期降准。这意味着流动性充裕的“放水”？明明是利好消息怎么周一的A股三大指数却集体收跌呢？且听金牛基金经理的权威解读！',
					},
					contentId: '697657892',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '基金',
							categoryLevel: '2',
						},
						categoryName: '混合型',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '【中邮基金国晓雯】降准后，A股怎么还跌了？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/35923/27/20954/21189/641918bcF6a04e426/129a68b3f0e04846.jpg?width=600&height=360',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '中邮创业基金管理股份有限公司',
					},
					title2: {
						text: '3小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697657892',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc110692',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/174061/8/11732/4797/60af0b2aE71cdd0e9/cbe8dfb1caf89c3c.png',
					jumpData: {
						jumpType: '6',
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/jdminiprogram/open?jrlogin=true&jrcontainer=native&jrparam=%7B%22type%22%3A%22%7B%5C%22des%5C%22%3A%5C%22vapp%5C%22%2C%5C%22vapptype%5C%22%3A%5C%221%5C%22%2C%5C%22appId%5C%22%3A%5C%22ao21ec956f5e3d1136%5C%22%2C%5C%22category%5C%22%3A%5C%22jump%5C%22%7D%22%7D',
						param: {
							type: '{"des":"vapp","vapptype":"1","appId":"ao21ec956f5e3d1136","category":"jump"}',
						},
						jumpUrl: '2024',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/75563/27/17319/41471/6267ab0eEf2d308d3/12b5875e0b375f2a.png!cc_50x50',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697657892',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697657892',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-7228',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697657892',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697657892',
							contentType: '1',
							createdPin: 'jimu_user_info-7228',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-7228',
							typeId: '4',
							pageId: '697657892',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc110692',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=008981&fundUtmSource=856&fundUtmParam=1002_71_697657892',
					},
					numContent: '-7.81%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '中邮科技创新精选混合C',
					optionalData: {
						inputData: {
							fundId: '110692',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697657892","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc110692"}',
							},
						},
						productId: '110692',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697657892","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc110692"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697654585\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '今日早盘，A股三大指数集体高开，军工板块开盘领涨。',
					},
					contentId: '697654585',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '这一板块终于迎来春天？快逢低上车！',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/41539/18/24196/82518/64190c08Fbb8f39e7/2a7a91f1d7052967.jpg?width=1336&height=802',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富动态',
					},
					title2: {
						text: '4小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697654585',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc106632',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845378',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/59728/23/20813/7982/63186b7dEf776a321/13546b80ab8b0fe6.jpg?width=288&height=288',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697654585',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697654585',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845378',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697654585',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697654585',
							contentType: '1',
							createdPin: 'jimu_user_info-2845378',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845378',
							typeId: '4',
							pageId: '697654585',
						},
						title: {
							text: '2',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc106632',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=001475&fundUtmSource=856&fundUtmParam=1002_71_697654585',
					},
					numContent: '-9.12%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '易方达国防军工混合A',
					optionalData: {
						inputData: {
							fundId: '106632',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697654585","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc106632"}',
							},
						},
						productId: '106632',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697654585","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc106632"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697500434\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '相关事件首个AI共创游戏设计将上线3月20日，据网易方面消息，由网易伏羲大模型提供技术支持的首个AI共创游戏设计，即将在《永劫无间》游戏内上线，玩家可以使用灵感词生成专属设计。另外，据报道，北京时间3月22日，微软将发布GDC（游戏开发者大会）2023全球点播页面。本次将通过33个议程带领游戏开发者探索创新的开发工具、商业策略与生态项目以加速游戏的开发、获客与成长等。事件点评生成式AI，为游戏注入',
					},
					contentId: '697500434',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '【热点挖掘】玩家们可以彻底放飞自我，游戏板块强势拉升！',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/111950/5/33277/57914/6417f93bF38bc9c54/1ab02579b221a48d.jpg?width=520&height=312',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '中国银河证券',
					},
					title2: {
						text: '23小时前',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697500434',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SZ-300059',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/jdminiprogram/open?jrlogin=true&jrcontainer=native&jrparam=%7B%22type%22%3A%22%7B%5C%22des%5C%22%3A%5C%22vapp%5C%22%2C%5C%22vapptype%5C%22%3A%5C%221%5C%22%2C%5C%22appId%5C%22%3A%5C%22DFEFCE0E722CAA7DA5E8A443C7689457%5C%22%2C%5C%22category%5C%22%3A%5C%22jump%5C%22%7D%22%7D',
						param: {
							type: '{"des":"vapp","vapptype":"1","appId":"DFEFCE0E722CAA7DA5E8A443C7689457","category":"jump"}',
						},
						jumpUrl: '2024',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg11.360buyimg.com/jrpmobile/jfs/t1/159881/40/23012/17649/6396e0c5Eeaf698db/c06c852a5c62094b.jpg!cc_50x50',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697500434',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697500434',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-7293',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697500434',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697500434',
							contentType: '1',
							createdPin: 'jimu_user_info-7293',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-7293',
							typeId: '4',
							pageId: '697500434',
						},
						title: {
							text: '1',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SZ-300059%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697500434%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+0.75%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '东方财富',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697498435\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '多模态AIGC模型的应用，预计可提升游戏的互动体验，进而提升行业需求，同时为大型游戏减少研发费用，为中小型游戏减少营销费用。',
					},
					contentId: '697498435',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '微软AI服务将现身游戏盛会 又一个被AIGC革命的行业来了？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/53956/3/24063/32192/6417ee32F0db52bfc/8af10790c38bbb5e.jpg?width=600&height=323',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-20 13:24',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697498435',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SZ-002558',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697498435',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697498435',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697498435',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697498435',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697498435',
						},
						title: {
							text: '1',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SZ-002558%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697498435%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+2.79%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '巨人网络',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697498378\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '本周5个交易日预计将有20只新基金发行。虽无法与此前超过30只时相比，但拉长时间来看，仍维持较高水平。',
					},
					contentId: '697498378',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '基金',
							categoryLevel: '2',
						},
						categoryName: '股票型',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '本周基金发行谁最热？FOF集中登场，猫头鹰捕捉华富陈启明、华夏许利明新品',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/186516/3/33168/737068/6417edf7Fb6041678/a406c9e1e5fc5d79.png?width=1203&height=626',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/203307/4/32160/74172/6417edf8F43c2eeff/225f08159d37e902.png?width=415&height=315',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/72981/1/24579/28216/6417edf8F6125b61a/8a688bfff2007301.png?width=602&height=265',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-20 13:23',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 3,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697498378',
						templateId: 588,
						contentType: 1,
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697498378',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697498378',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697498378',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697498378',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697498378',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697497408\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '相比于四折贱卖瑞信股票的股东们，有一群人无疑更为“倒霉”——那就是价值约160亿瑞郎(约合172亿美元)的瑞信额外一级资本(AT1)债券的持有者，因为他们才真正向世人演绎了：在本轮欧美银行业风暴中，什么才叫“血本无归”……',
					},
					contentId: '697497408',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '债券',
							categoryLevel: '2',
						},
						categoryName: '公司债券',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '172亿美元瞬间清零！瑞信危机中真正“血本无归”的人出现了……',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/221344/33/25081/111950/6417e874F2e0ef7a5/ba6e23be75edbf27.bmp?width=607&height=344',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/200470/19/31719/21125/6417e874Ff463191d/69c50aeceb8f764a.bmp?width=627&height=374',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/105780/13/36848/17006/6417e874F6b1fac9e/4b1c0e79a8501dfd.jpg?width=500&height=286',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/163595/24/32002/33148/6417e874F50880b94/b2c331a711a94bc5.bmp?width=651&height=376',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-20 13:00',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 3,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697497408',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc107717',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697497408',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697497408',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697497408',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '10',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697497408',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697497408',
						},
						title: {
							text: '3',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc107717',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=004598&fundUtmSource=856&fundUtmParam=1002_71_697497408',
					},
					numContent: '-5.63%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '南方中证银行ETF发起联接C',
					optionalData: {
						inputData: {
							fundId: '107717',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697497408","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc107717"}',
							},
						},
						productId: '107717',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697497408","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc107717"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697489400\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '社会科学研究网络（Social Science Research Network）最近刊登的一项研究表明，如果一半的储户突然提取资金，186家美国银行可能会倒闭。',
					},
					contentId: '697489400',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '时事',
								categoryLevel: '1',
							},
							categoryName: '国际',
							categoryLevel: '2',
						},
						categoryName: '美国',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '红色警报！研究：美国近190家银行有“SVB式”爆雷风险',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/192067/40/34609/133434/6417cbbfF80267550/7f9be7af410b8e81.jpg?width=2500&height=1667',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-20 10:58',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697489400',
						templateId: 588,
						contentType: 1,
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697489400',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697489400',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697489400',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697489400',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697489400',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697148012\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '此次全面降准将从经济基本面、市场风险偏好和货币政策三方面对A股市场形成提振',
					},
					contentId: '697148012',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '央行意外降准！A股一定会涨吗？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/219092/22/24410/223267/641527b2F49a906a2/3c9c959046d990d6.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '03-20 10:57',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697148012',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SH-601878',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697148012',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697148012',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697148012',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '84',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697148012',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697148012',
						},
						title: {
							text: '12',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SH-601878%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697148012%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+0.30%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '浙商证券',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697486554\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '正如美银首席投资策略师哈奈特(Michael Hartnett)所指出的那样——“当中央银行开始恐慌时，市场就会停止恐慌”……',
					},
					contentId: '697486554',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: '全球股市',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '又一个关键周一！当央行开始恐慌时 市场会停止恐慌吗？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/214279/26/27254/16705/6417b5f2Fcf412e60/f5a6b1cc91a0b488.bmp?width=619&height=392',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/149570/11/35251/11373/6417b5f2F1918d479/1b015df5c96aeadd.jpg?width=500&height=256',
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/139350/19/34197/18414/6417b5f3F5b3a3f52/ff913bb29f829fba.bmp?width=1032&height=491',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-20 09:24',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 3,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697486554',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SH-601166',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697486554',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697486554',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697486554',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '25',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697486554',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '697486554',
						},
						title: {
							text: '4',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SH-601166%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697486554%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '-0.12%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '兴业银行',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697482134\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '降准消息宣布后一周市场普涨',
					},
					contentId: '697482134',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '从历史经验看预计降准消息宣布后一周市场普涨',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/206335/32/28633/268046/6417a867F2f83ddc4/38ec30071402fa3d.jpg?width=1798&height=1079',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '研报掘金',
					},
					title2: {
						text: '03-20 08:39',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697482134',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SH-600030',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2872757',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/202087/19/26180/4526/63186b48E9259170f/7d4e9c764d0df59c.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697482134',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697482134',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2872757',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697482134',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697482134',
							contentType: '1',
							createdPin: 'jimu_user_info-2872757',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2872757',
							typeId: '4',
							pageId: '697482134',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SH-600030%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697482134%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+0.85%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '中信证券',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697378945\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '千万不要轻易中断复利累积',
					},
					contentId: '697378945',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '还在看空就是没常识？大佬重磅发声！',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/108279/39/36650/243754/6416c05bFfa9e633c/5d33b5a62e9c704b.jpg?width=1999&height=1200',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '研报掘金',
					},
					title2: {
						text: '03-20 08:18',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697378945',
						templateId: 588,
						contentType: 1,
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2872757',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/202087/19/26180/4526/63186b48E9259170f/7d4e9c764d0df59c.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697378945',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697378945',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2872757',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697378945',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '2',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697378945',
							contentType: '1',
							createdPin: 'jimu_user_info-2872757',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2872757',
							typeId: '4',
							pageId: '697378945',
						},
						title: {
							text: '2',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697402563\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '当前行情下我们推荐组合进行哑铃型配置，分别以小市值和大市值进行哑铃组合，具体标的上我们推荐关注小市值代表中证1000和大市值代表上证180。',
					},
					contentId: '697402563',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '基金',
							categoryLevel: '2',
						},
						categoryName: '指数型',
						categoryLevel: '3',
					},
					contentTitle: {
						text: 'A股结构性行情新玩法？上证180+中证1000',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/192611/3/33560/223267/6416d2ecFf81ebdee/c4cb22762a83cd76.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '03-20 06:59',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697402563',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc105327',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697402563',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697402563',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697402563',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '5',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697402563',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697402563',
						},
						title: {
							text: '6',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc105327',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=519180&fundUtmSource=856&fundUtmParam=1002_71_697402563',
					},
					numContent: '-5.70%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '万家180指数',
					optionalData: {
						inputData: {
							fundId: '105327',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697402563","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc105327"}',
							},
						},
						productId: '105327',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697402563","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc105327"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697391699\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '价值投资的回归将是2023年市场风格主线',
					},
					contentId: '697391699',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: 'A股',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '揭秘！A股市场主线密码已经破解？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/206542/4/31552/55702/6416e46eF1131a964/0ed7613ee09ebabe.png?width=692&height=341',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/187997/7/32833/73021/6416e46cFc9e362ce/52ace20740216850.png?width=712&height=367',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/137557/1/34037/46915/6416e46dF8eaafec1/a532e99d663f171d.png?width=547&height=417',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/213286/10/27242/61508/6416e46cF711fcaaf/6bec0d9c61a288ff.png?width=552&height=354',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/138309/12/29454/43453/6416e46cF6e3f9c83/a6bd0142c9869e5b.png?width=544&height=359',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/139133/11/33594/65385/6416e46dFddbe5ed2/4887881efede6562.png?width=695&height=281',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/98138/6/31148/59233/6416e46cF2f6210de/ab1a1cfac3a26ae4.png?width=537&height=362',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/124496/34/32071/60667/6416e46cF132e1824/d9f0004346bf454a.png?width=690&height=283',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/135405/27/35806/77485/6416e46dFf5635d98/f21fd32345e2728f.png?width=700&height=285',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/140111/1/33655/24131/6416e46eFedbdd35d/6f8669868e41e49f.png?width=548&height=338',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/117699/34/33113/61888/6416e46dF3eea0cda/03e9918670261e85.png?width=554&height=325',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/120138/33/30923/80721/6416e46dF707453b4/735bd15b14a3a4b5.png?width=704&height=290',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/80870/31/25882/68299/6416e46cFf2bef2a0/eec04f1e566dc21b.png?width=696&height=306',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/185401/16/34369/73945/6416e46dF827bf82a/0d5281e44a76f846.png?width=551&height=368',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/81337/30/24656/69866/6416e46dF0ee2acbe/72cf63f0edc2753c.png?width=698&height=288',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/67723/4/23902/53191/6416e46dF7e7bc60d/75512700383d43b1.png?width=546&height=339',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/71598/21/22220/69249/6416e46eF687c342d/4fd2c2fd90795d65.png?width=550&height=321',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/126877/12/30714/44976/6416e46dFbcb41bdc/1baa39222c50fa8e.png?width=545&height=324',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/216356/6/27288/59920/6416e46eF23429e5b/6513307b2422b066.png?width=706&height=290',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/213046/24/27298/75549/6416e46dFa4129246/21f8abefec90603c.png?width=693&height=302',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/117289/1/33240/79841/6416e46eFa1b70644/1dcc5a11ba63b15e.png?width=705&height=336',
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/97678/21/36155/83802/6416e46dF8ce08539/b7d3a4179d045c1a.png?width=705&height=320',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '研报掘金',
					},
					title2: {
						text: '03-20 06:33',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 3,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697391699',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SZ-002673',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2872757',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/202087/19/26180/4526/63186b48E9259170f/7d4e9c764d0df59c.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697391699',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697391699',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2872757',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697391699',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '1',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697391699',
							contentType: '1',
							createdPin: 'jimu_user_info-2872757',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2872757',
							typeId: '4',
							pageId: '697391699',
						},
						title: {
							text: '3',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#EF4034',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SZ-002673%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_697391699%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '+0.64%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/143894/2/11118/1433/5f886398Eeb20d41e/c871fae54a050898.png',
					skuType: 0,
					trackData: {},
					content: '西部证券',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697455011\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '本周市场表现:黄金>港股>美股>债券>A股>商品',
					},
					contentId: '697455011',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '股票',
							categoryLevel: '2',
						},
						categoryName: '全球股市',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '财富投研每周谈:市场向下空间不大，耐心等待机会',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/30804/19/21357/223267/6416fad3F3172d140/4d6dd72706a139f2.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '03-19 21:43',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697455011',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc107717',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697455011',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697455011',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697455011',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697455011',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697455011',
						},
						title: {
							text: '3',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc107717',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=004598&fundUtmSource=856&fundUtmParam=1002_71_697455011',
					},
					numContent: '-5.63%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '南方中证银行ETF发起联接C',
					optionalData: {
						inputData: {
							fundId: '107717',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697455011","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc107717"}',
							},
						},
						productId: '107717',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697455011","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc107717"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"697167272\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '虽然春节后经济基本面复苏强劲，信贷数据也较为理想，中长端利率债一度承压，但近期市场情绪反复，短债和存单指数均存在一定的配置机会。',
					},
					contentId: '697167272',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '期货',
							categoryLevel: '2',
						},
						categoryName: '其他',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '30年期国债期货王者归来！债基迎来配置机会？',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/jrpmobile/s450x750_jfs/t1/214288/15/26764/223267/6415a86bF9b5c1090/5298e815ba4dd248.jpg?width=1765&height=1059',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '财富解码',
					},
					title2: {
						text: '03-18 20:05',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '697167272',
						templateId: 588,
						skuType: 0,
						contentType: 1,
						skuId: 'fc106531',
					},
				},
				avatarData: {
					gradeImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/194754/28/298/4489/608908caE5c744ae6/37ea9341405f471b.png',
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-2845386',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://kjimg10.360buyimg.com/jrpmobile/jfs/t1/188267/11/28715/4526/63186b68Ec65ccbe0/08231263e832a7c4.jpg?width=144&height=144',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '697167272',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '697167272',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-2845386',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '697167272',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '1',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '697167272',
							contentType: '1',
							createdPin: 'jimu_user_info-2845386',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-2845386',
							typeId: '4',
							pageId: '697167272',
						},
						title: {
							text: '4',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						jumpType: '7',
						productId: 'fc106531',
						jumpUrl:
							'https://lc.jr.jd.com/finance/fund/latestdetail/index/?fundCode=400029&fundUtmSource=856&fundUtmParam=1002_71_697167272',
					},
					numContent: '-0.61%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '东方双债添利债券C类',
					optionalData: {
						inputData: {
							fundId: '106531',
							systemId: '71_588',
						},
						attentionTitle2: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/182223/19/30981/2022/637f741fEed9a46ab/2ae79d1217874147.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_取消自选","contentid":"697167272","skuidtype":"取消自选","ordid":"*0*0-0","skuid":"fc106531"}',
							},
						},
						productId: '106531',
						attentionTitle1: {
							icon: 'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/51319/14/18129/1271/637f73edE90b0595c/d19f1bf2c9275fb8.png?width=48&height=50',
							trackData: {
								bid: '74274',
								matid: '',
								ctp: '70000',
								paramJson:
									'{"busid":"588","sysCode":"mc-mkt-cms","posid":"*49140*84234","staid":"71","pagid":"0","matid":"基金胶囊_添加自选","contentid":"697167272","skuidtype":"添加自选","ordid":"*0*0-0","skuid":"fc106531"}',
							},
						},
						productType: 0,
						status: 0,
					},
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
		{
			templateType: 588,
			templateInstanceKey:
				'{"templateType":588,"legoSingleTemplateParams":"{\\"isTop\\":false,\\"contentId\\":\\"696962523\\",\\"sceneId\\":71,\\"source\\":\\"content\\",\\"contentType\\":1,\\"contentParams\\":{\\"subjectId\\":\\"2710472\\"}}"}',
			templateData: {
				eid: '84234',
				contentData: {
					contentTitle2: {
						text: '本次降准将为银行每年节约资金成本56至60亿。',
					},
					contentId: '696962523',
					secureStatus: 1,
					categoryTree: {
						parent: {
							parent: {
								categoryName: '财经',
								categoryLevel: '1',
							},
							categoryName: '产业经济',
							categoryLevel: '2',
						},
						categoryName: '金融业',
						categoryLevel: '3',
					},
					contentTitle: {
						text: '超预期降准25BP对债市影响几何？资金面久旱逢甘霖',
					},
					imageList: [
						'https://kjimg10.360buyimg.com/recarticle/jfs/t1/173658/9/34867/58705/641462d0F60a0db93/6f165b32f9f60e5a.jpg?width=1000&height=667',
					],
					contentType: 1,
				},
				tagId: 71,
				browseCount: '',
				titleData: {
					title1: {
						text: '国金证券',
					},
					title2: {
						text: '03-17 20:53',
					},
					icon3: {},
					title6: {},
				},
				templateStyle: 2,
				iosSubmissionStatus: '0',
				shareNum: {},
				trackData: {},
				bindKey: '',
				pitOrderNum: '',
				templateConfig: {
					paddingBottom: '10',
					bgColor: '',
					paddingLeft: '12',
					paddingRight: '12',
					cornerRadius: '4',
				},
				relateData: {
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/38309/38/16432/4286/60f13883Ea27e2b71/893abcf9de9b4313.png',
					goodsBgColor: '#FAFAFA',
					title: {},
					relatedRecommendInputData: {
						tagId: 71,
						contentId: '696962523',
						templateId: 588,
						skuType: 6,
						contentType: 1,
						skuId: 'SH-601818',
					},
				},
				avatarData: {
					jumpData: {
						jumpType: '6',
						productId: 'jimu_user_info-38498',
						jumpUrl: '40',
					},
					avatarType: '1',
					trackData: {},
					avatarImgUrl:
						'https://img12.360buyimg.com/jrpmobile/jfs/t1/64819/16/21065/2142/62f4f77eE60a5222b/40e28c4b5dcde52a.jpg',
				},
				pitNum: '',
				jumpData: {
					jumpType: '6',
					productId: '696962523',
					param: {},
					jumpUrl: '59',
				},
				busOrgCode: '',
				attentionData: {
					followOperate: '-1',
					attentionTitle2: {
						title: {
							bgColor: '#FFFFFF',
							text: '已关注',
							textColor: '#999999',
						},
						trackData: {
							bid: '74274',
							matid: '',
							ctp: '70000',
							paramJson:
								'{"sysCode":"mc-mkt-cms","posid":"*49140*84234","pagid":"0","matid":"**","ordid":"*0*0-0"}',
						},
					},
					attentionInputData: {
						sourceId: '696962523',
						bizType: 17,
						sourceType: 1,
						followChannel: 0,
						content: 'jimu_user_info-38498',
					},
					attentionTitle1: {
						title: {
							bgColor: '#FFFFFF',
							textColor: '#EF4034',
							text: '关注',
						},
						trackData: {},
					},
				},
				interactData: {
					comentData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/61476/16/23790/1937/63e2464fFbcc2a7e5/b5334497e08f9762.png?width=60&height=60',
						commentNum: '0',
						jumpData: {
							jumpType: '6',
							productId: '696962523',
							param: {},
							jumpUrl: '59',
						},
						title: {
							text: '评论',
							textColor: '#666666',
						},
						trackData: {},
					},
					shareData: {
						imgUrl:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/178637/26/33190/1976/63e4b9c6F5072d3cd/26e05a91b79b5180.png?width=60&height=60',
						shareInputData: {
							contentId: '696962523',
							contentType: '1',
							createdPin: 'jimu_user_info-38498',
						},
						title: {
							text: '分享',
							textColor: '#666666',
						},
						trackData: {},
					},
					praiseData: {
						laudNum: '0',
						imgUrlPraise:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/10663/31/17892/995/62b971a3E7d40c836/cbc9caa921dfd8d1.png?width=48&height=48',
						laudOperate: 0,
						praiseInputData: {
							authorPin: 'jimu_user_info-38498',
							typeId: '4',
							pageId: '696962523',
						},
						title: {
							text: '点赞',
							textColor: '#666666',
						},
						trackDataCancel: {},
						trackData: {},
						imgUrlCancel:
							'https://kjimg10.360buyimg.com/mcmktadmin/jfs/t1/188997/15/31999/1429/63e4b9d1Fc6b5bf57/024a88b9d6d58a43.png?width=60&height=60',
					},
				},
				skuInfo: {
					numContentColor: '#1DB270',
					forward: {
						schemeUrl:
							'openjdjrapp://com.jd.jrapp/stock/jump?jrparam=%7B%22extJson%22%3A%22%7B%5C%22p%5C%22%3A%5C%22SH-601818%5C%22%2C%5C%22ref%5C%22%3A%5C%22sq_nr_1002_71_696962523%5C%22%2C%5C%22t%5C%22%3A%5C%22gos%5C%22%7D%22%7D&jrlogin=false&jrcontainer=native',
					},
					numContent: '-0.32%',
					icon: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/153048/26/2391/1447/5f8863e2E0c3386d6/bbb848f690db4b47.png',
					skuType: 2,
					trackData: {},
					content: '光大银行',
				},
				qualityContentData: {
					title: {},
				},
			},
			templateExtStyle: {
				exposurePercentage: 50,
			},
			buildCode: 'feeds',
			templateId: 49140,
			templateTrackData: '',
			templateIndex: 1,
			hasError: false,
			templateBgColor: '',
			templateKey: '',
		},
	],
	isEnd: false,
};
